import { render, staticRenderFns } from "./SingleHistogram.vue?vue&type=template&id=7094498c&scoped=true"
import script from "./SingleHistogram.vue?vue&type=script&lang=js"
export * from "./SingleHistogram.vue?vue&type=script&lang=js"
import style0 from "./SingleHistogram.vue?vue&type=style&index=0&id=7094498c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7094498c",
  null
  
)

export default component.exports